import { Component, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LocalService, TriggeredEvent } from '../../../service/local.service';

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box.component.html',
  styleUrl: './message-box.component.scss'
})
export class MessageBoxComponent {
  @Input() message: string; @Input() IsHtmlMessage = false; @Input() IsHeaderVisible = true;
  @Input() IsConfirmationType = false; @Input() header = ''; @Input() customButtonText = '';
  @Input() timerValue: number | undefined = undefined;//In seconds 
  @Input() IsYesPrimaryOnConfirmationType = false;
  @Output() onClose = new EventEmitter(); @Input() IsPopup = false; htmlMessage: any;

  interval; timerCount = 0; maxBodyHeight = 0;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    if (this.IsHtmlMessage) {
      this.getHtml();
    }

    if (this.timerValue) {
      this.startTimer();
    }
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onPopupClose() {
    this.onClose.emit({ event: TriggeredEvent.Close });
  }

  onConfirmed(isConfirmed) {
    this.onClose.emit({ event: isConfirmed ? TriggeredEvent.Ok : TriggeredEvent.Close });
  }

  getHtml() {
    this.message = this.localService.replaceAll(this.message, '<br>', '');

    this.htmlMessage = this.sanitizer.bypassSecurityTrustHtml(this.message);
  }

  startTimer() {
    this.timerCount = this.timerValue;
    this.interval = setInterval(() => {
      this.timerCount--;
      if (this.timerCount == 0) {
        this.onConfirmed(true);
      }
    }, 1000); //1 sec
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }
}
